import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit {

  @Input() numberOfStars: number = 0;
  @Input() fontSize: string = "15px";
  @Input() disableTooltip: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
